import { PagenatedResponse, SearchPagenateQuery, UserEventRecord } from '@models/common';
import { apiClient } from '.';

export const searchUserEventRecords = async (query?: SearchPagenateQuery) => {
  return apiClient.get<PagenatedResponse<UserEventRecord>>(`/admin/v1/event-records`, {
    params: query,
  });
};

export const getUserEventRecordsExcel = async (query?: SearchPagenateQuery) => {
  return apiClient.get(`/admin/v1/event-records/export`, {
    responseType: 'blob',
    headers: { 'Cache-Control': 'no-cache' },
    params: query,
  });
};
